/**
 * AUTO-GENERATED — do not edit manually.
 * Regenerate: node backend/scripts/generate-city-price-report.js
 * Last run: 2026-09-17T22:05:12.913Z
 */
export const cityPriceStats = {
  'Madrid': {
    generatedAt: '2026-09-17',
    totalListings: 459,
    listingsLabel: '456+',
    minPrice: 155,
    displayMinPrice: 450,
    maxPrice: 3900,
    avgPrice: 828,
    medianPrice: 650,
    priceRange: '450€ - 3900€',
    avgPriceDisplay: 828,
    currency: 'EUR',
  },
  'Barcelona': {
    generatedAt: '2026-09-17',
    totalListings: 263,
    listingsLabel: '260+',
    minPrice: 450,
    displayMinPrice: 450,
    maxPrice: 5130,
    avgPrice: 1007,
    medianPrice: 815,
    priceRange: '450€ - 5130€',
    avgPriceDisplay: 1007,
    currency: 'EUR',
  },
  'New York': {
    generatedAt: '2026-09-17',
    totalListings: 392,
    listingsLabel: '392+',
    minPrice: 660,
    displayMinPrice: 660,
    maxPrice: 17250,
    avgPrice: 4845,
    medianPrice: 2542,
    priceRange: '$660 - $17,250',
    avgPriceDisplay: "$4,845/mo",
    currency: 'USD',
  }
};

export const cityPriceStatsGeneratedAt = '2026-09-17';
